import { render } from "./AddOrEditFaq.vue?vue&type=template&id=73721e6a"
import script from "./AddOrEditFaq.vue?vue&type=script&lang=js"
export * from "./AddOrEditFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__